module.exports = __webpack_public_path__ + "static/img/wendajia.910875d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buyersShow/wendajia.png
// module id = njR/
// module chunks = 1